import { Injectable } from '@angular/core';
import { SoftwareType } from '@nimmsta/ng-commons-lib/models';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';

@Injectable({
  providedIn: 'root',
})
export class SoftwareTypeService extends WorkflowDataService<SoftwareType> {
  protected override get apiEndpoint(): string {
    return '/softwareTypes';
  }
}
